<div class="row">
  <div class="lqd-column col-md-4 moneto-content">
    <h2 appTranslate="account.create.title"></h2>
    <p appTranslate="account.create.text"></p>
  </div>
  <div class="lqd-column col-md-8 pt-md-6 moneto-form">
    <!-- <app-checkbox-control *ngIf="logged" [control]="control"></app-checkbox-control> -->
    <div *ngIf="isFormVisible()" class="contact-form contact-form-inputs-filled contact-form-inputs-circle contact-form-button-block contact-form-button-circle mb-60 mt-40">
      <div>
        <span appTranslate="password"></span>
        <app-password-control class="bg-gray" #passwordField [confirm]="confirmPasswordField" [control]="password" [form]="form"></app-password-control>
      </div>
      <div>
        <span appTranslate="confirmPassword"></span>
        <app-password-confirm-control class="bg-gray" #confirmPasswordField [parent]="passwordField" [control]="confirmPassword" [form]="form"></app-password-confirm-control>
      </div>
    </div>
  </div>
</div>


